module.exports = __webpack_public_path__ + "static/Studio-04a91e2d5a373004d95704735af322f0.mp4";